if (!customElements.get('toast-notification')) {
  customElements.define(
    'deployer-toast-notification',
    class DeployerToastNotification extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.content');
        this.successIcon = this.querySelector('.icon-success');
        this.errorIcon = this.querySelector('.icon-error');
        this.infoIcon = this.querySelector('.icon-info');
        this.warningIcon = this.querySelector('.icon-warning');

        this.delay = 3000;

        document.addEventListener('toast:open', (e) => {
          this.open();

          switch (e.detail.type) {
            case 'success':
              this.setSuccessMode(e.detail.message);
              break;
            case 'error':
              this.setErrorMode(e.detail.message);
              break;
            case 'warning':
              this.setWarningMode(e.detail.message);
              break;
            default:
              this.setInfoMode(e.detail.message);
              break;
          }

          setTimeout(() => {
            this.close();
          }, this.delay);
        });
      }

      open() {
        this.classList.add('active');
      }

      close() {
        this.classList.remove('active');
      }

      setInfoMode(message) {
        this.content.innerHTML = message || 'Information';
        this.resetState();
        this.classList.add('info');
      }

      setWarningMode(message) {
        this.content.innerHTML = message || 'Attention !';
        this.resetState();
        this.classList.add('warning');
      }

      setErrorMode(message) {
        this.content.innerHTML = message || 'Erreur !';
        this.resetState();
        this.classList.add('error');
      }

      setSuccessMode(message) {
        this.content.innerHTML = message || 'Succès !';
        this.resetState();
        this.classList.add('success');
      }

      resetState() {
        this.classList.remove('info');
        this.classList.remove('warning');
        this.classList.remove('error');
        this.classList.remove('success');
      }
    }
  );
}
